import messages from './clonar-modal-translations';
import * as $ from 'jquery';
import { ClonarMapaService } from './services/clonarMapaService';
import { AuthService } from '../../../login/services/authService.js';


export default {
    name: 'instamapsClonarModal',
    i18n: {
        messages,
    },
    data(){
        return {
            form: {
                nom: "",
            }
        };
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#clonar-modal-body').attr("style","display:block;");
                $('#clonar-modal-msg').attr("style","display:none;");
                $('#clonar-modal-msg2').attr("style","display:none;");
                $('#clonar-modal').addClass('animate-flex-modal');                
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#clonar-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        showMessageDuplicate: function(){
            $('#clonar-modal-body').attr("style","display:none;");
            $('#clonar-modal-msg').attr("style","display:block;");
            $('#clonar-modal-msg2').attr("style","display:none;");
        },
        showMessageNoLogat: function(){
            $('#clonar-modal-body').attr("style","display:none;");
            $('#clonar-modal-msg').attr("style","display:none;");
            $('#clonar-modal-msg2').attr("style","display:block;");
        },
        clonarMapa: function(){
            this.$validator.validateAll().then((result) => {
                if (result) {                   
                    var uid = AuthService.getUid();
                    if (uid != null) { 
                        this.showMessageDuplicate();
                        ClonarMapaService.migrateMap(this.mapa.businessId, this.form.nom).then((response) => {
                            if (response.status==="OK") {
                                this.$emit('migrateMap', {businessId: response.results.businessId});
                                this.dismiss();
                            }else{
                                this.dismiss();
                                this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                            }
                        }).catch(() => {
                            this.dismiss();
                            this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                        });
                    }
                    else {
                        this.showMessageNoLogat();
                    }
                }
            });
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/gallery/components/clonar-modal/clonar-modal.js